module.exports = __webpack_public_path__ + "img/mgrt.51c324a3.jpg";